<template>
     <form @submit.prevent="fnSubmitData" >
        <div class="searchcasestudies">
            <input type="text" v-model="$store.state.currentsearch" :placeholder="searchlabel"  v-on:keyup="fnOnKeyUp" /> 
            <span @click="fnSubmitData"></span> 
        </div>
     </form>
 
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"

// eslint-disable-next-line no-unused-vars

export default {
  name: "cmpsearchcasestudies",
  mixins:[multilangmixin],
  emits:["sigfilterchanged"],
  props:["initialsearchcasestudies"],
    

  data(){
      return {

            };
  },

  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);
    this.fnInitFromQueryString();
    
  },

  computed:{
    
    searchlabel(){
      return this.fnGetTranslation(this.currentlang,"search");

    },

    currentsearch:{
        get(){
          return this.$store.state.currentsearch;
        },
        set(newvalue){
          this.$store.commit("fnSetCurrentSearch",newvalue);
        }
      
    },

 


  },


  methods:{

/*
        fnOnKeyUp(e){
            if (e.keyCode==13)
            {
              this.fnSubmitData();     
            }
        },

        */

         fnSubmitData(){
            
            //console.log("fnSubmitData");
            this.fnEmitFilterChanged();

        },



        fnEmitFilterChanged(){
            //console.log("emit");
            this.$emit("sigfilterchanged");
        },


        fnInitFromQueryString()
        {
          let wSearch=this.fnGetQueryParam("search");
          if (wSearch!=undefined)
          {
            this.currentsearch=wSearch;
          }
        
        }



  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    


  .searchcasestudies
  {
  
    padding-bottom: 2vh; 
    display: flex;
    
    justify-content:  space-between;
    

  }

  .searchcasestudies input
  {
    
      border-color: #ffdd00;
      border-top-style: solid;
      border-left-style: solid;
      border-bottom-style: solid;
      border-right-style: solid;
      
      border-width: 1px;
      font-weight: 500;
      font-size: 1.2em;

      width: 100%;

          

  }

  .searchcasestudies input:focus
  {
    outline: none;
  }

  .searchcasestudies span
  {
      border-width: 1px;
      border-color: #ffdd00;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left: none;

      background-image: url("~@/assets/images/search.svg");
      background-size: contain;
      background-position: right;
      background-repeat: no-repeat;
      width: 30px;
  }


  .searchcasestudies span:hover
  {
      background-color: #ffdd00;
      border-width: 1px;
      border-color: #ffdd00;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left: none;

      background-image: url("~@/assets/images/search.svg");
      background-size: contain;
      background-position: right;
      background-repeat: no-repeat;
      width: 30px;
  }

  
  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
 
     .searchcasestudies{
        width: 270px;
      }

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
  
 
  }


</style>
